<template>
  <div id="about">
    <div id="close-button-fixed">
      <img
        @click="$router.push({ path: '/' })"
        id="close-button"
        src="../assets/close_button.png"
        alt="close impressum"
      />
    </div>
    <h1 id="about-title">ECCHR Explore</h1>

    <h1>About this app</h1>

    <h2>ECCHR Explore is built in collaboration with metasphere</h2>
    <div class="text-box">
      metasphere facilitates the transformation of information into knowledge.
      With a focus on interaction design and data science, they work on
      technologies that enable humans to embrace the ever-increasing complexity
      of our communications. Giving insights into the layered and interconnected
      interactions between a multitude of voices, they aim to make sensemaking
      more accessible, transparent, and tangible.
      <br />
      <br />
      With this app, want to tap into the wealth of information hidden in the
      inflexible and static format of audio content. By adding a visual layer to
      the auditory content, we are encouraging consumers to engage with the
      content actively and provide functionalities to augment the experience of
      consuming audio content in a way conducive to more efficient information
      retrieval, knowledge acquisition and internalization, as well as increased
      accessibility for the hearing impaired.
    </div>
    <div class="hoirzontal-separator"></div>

    <h3>
      Responsible for the <br />
      content of this website
    </h3>

    <div class="text-box-small">
      European Center for Constitutional <br />
      and Human Rights e.V. <br />
      Zossener Straße 55–58 10961 Berlin, Germany <br />
      info@ecchr.eu
    </div>

    <h3>Concept, design and <br />development</h3>

    <div class="text-box-small">
      metasphere c/o <br />
      Sunsten UG (haftungsbeschränkt) <br />
      Waldemarstraße 38 <br />
      10999 Berlin, Germany <br />
      info@metasphere.xyz
    </div>

    <h3><strong>www.metasphere.xyz</strong></h3>

    <div class="hoirzontal-separator"></div>
    <h4>Version</h4>
    <div class="text">{{ version_main }}</div>
    <!-- <div class="text">{{ version_dev }}</div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      version_main: "",
      version_dev: "",
    };
  },
  mounted() {
    fetch("https://ecchr.metasphere.xyz/VERSION.txt")
      .then((response) => response.text())
      .then((data) => (this.version_main = data));
    fetch("https://dev.ecchr.metasphere.xyz/VERSION.txt")
      .then((response) => response.text())
      .then((data) => (this.version_dev = data));
  },
};
</script>

<style scoped>
#about {
  margin-top: 10px;
  margin-bottom: 30px;
  margin-left: 38px;
  overflow-y: scroll;
  padding-right: 20px;
}

#about-title {
  width: 190px;
  padding-bottom: 30px;
}

#close-button {
  width: 32px;
  position: sticky;
  padding-top: 20px;
  padding-right: 20px;
  top: 0px;
  left: 90%;
}

#close-button-fixed {
  position: absolute;
  right: 0px;
  left: 0px;
  width: 375px;
  z-index: 1;
}

h1 {
  margin-top: 40px;
  font-size: 28px;
  margin-bottom: 35px;
  padding-right: 35px;
}

h2 {
  font-size: 16px;
  font-weight: 500;
  width: 240px;
}

h3 {
  padding-top: 20px;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  width: 240px;
}

h4 {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 4px;
}
.text {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: left;
  color: rgba(235, 235, 245, 0.6);
  padding-right: 35px;
}

.text-box {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: left;
  color: rgba(235, 235, 245, 0.6);
  padding-right: 35px;
}

.text-box-small {
  padding-bottom: 20px;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0px;
  text-align: left;
  color: rgba(235, 235, 245, 0.6);
  padding-right: 35px;
}

.hoirzontal-separator {
  margin: 40px 25px 20px 0px;
  width: inherit;
  border: 1px solid rgba(58, 58, 60);
}
</style>